import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=33c3f69a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=33c3f69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3f69a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c3f69a')) {
      api.createRecord('33c3f69a', component.options)
    } else {
      api.reload('33c3f69a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=33c3f69a&scoped=true&", function () {
      api.rerender('33c3f69a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XmXlExkjPaSs/JS/comp/DocBox.vue"
export default component.exports